import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getPriceFormattedWithAlternates } from '@core/infrastructure/state/core.selectors';
import { CommonPriceCurrenciesFormatted } from '@frontend/common/currency';
import { UnitPrice } from '@shared/prices/models/product-prices.model';

@Component({
    selector: 'product-unit-price',
    templateUrl: './product-unit-price.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ NgIf, AsyncPipe ],
    standalone: true,
})
export class ProductUnitPriceComponent implements OnChanges {
    @Input() public unitPrice: UnitPrice;

    public formattedPrice$: Observable<CommonPriceCurrenciesFormatted>;

    constructor(private readonly store: Store) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.unitPrice.firstChange || changes.unitPrice.currentValue !== changes.unitPrice.previousValue) {
            this.formattedPrice$ = this.store.select(getPriceFormattedWithAlternates(this.unitPrice?.price, ''));
        }
    }
}
